<template>
  <div class="width98 margin-auto">
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>

    <div
      class="width100 backwhite"
      style="min-height: calc(100vh - 110px)"
      v-if="searchcont"
    >
      <div class="width30 margin-auto" style="padding-top: 22vh">
        <img class="width85" src="@/assets/barsvg/1zl@2x.png" alt="" />
      </div>
      <div class="margin-top40">
        <el-input
          class="width60 Keywordsinput cursorpointer"
          placeholder="请输入专利名称检索"
          v-model="input2"
        >
          <template slot="append">
            <span @click="searchclick">检索</span></template
          >
        </el-input>
      </div>

      <p class="searchchange cursorpointer margin-right50" @click="changecont">
        表格检索 <i slot="prefix" class="el-icon-arrow-right"></i>
      </p>
    </div>

    <div class="width100" v-if="maincont">
      <!-- 检索 -->
      <div
        class="backwhite border-rd3 flexleft pad-top10 pad-bot10"
        style="min-height: 120px"
        v-if="serchkey"
      >
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          size="small"
          label-width="100px"
          class="demo-ruleForm width100 flexleft"
        >
          <el-form-item label="查询方式">
            <el-select
              v-model="ruleForm.query_type"
              placeholder="请选择查询方式"
              :filterable="true"
              class="width100"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in optiontype"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专利名称">
            <el-input
              placeholder="请输入专利名称"
              v-model="ruleForm.title"
            ></el-input>
          </el-form-item>
          <el-form-item label="发明人名称">
            <el-input
              placeholder="请输入发明人名称"
              v-model="ruleForm.invetro"
            ></el-input>
          </el-form-item>
          <el-form-item label="代理机构名称">
            <el-input
              placeholder="请输入代理机构名称"
              v-model="ruleForm.agency"
            ></el-input>
          </el-form-item>
          <el-form-item label="权利人名称">
            <el-input
              placeholder="请输入权利人名称"
              v-model="ruleForm.patentee"
            ></el-input>
          </el-form-item>
          <el-form-item label="权利人地址">
            <el-input
              placeholder="请输入权利人地址"
              v-model="ruleForm.address"
            ></el-input>
          </el-form-item>
          <el-form-item label="专利类型">
            <el-select
              v-model="ruleForm.db"
              placeholder="请输入专利类型"
              class="width100"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="ipc分类号">
            <el-input
              placeholder="请输入ipc分类号"
              v-model="ruleForm.ipc"
            ></el-input>
          </el-form-item>
          <el-form-item label="申请号">
            <el-input
              placeholder="请输入申请号"
              v-model="ruleForm.app_number"
            ></el-input>
          </el-form-item>
          <el-form-item label="公开号">
            <el-input
              placeholder="请输入公开号"
              v-model="ruleForm.pub_number"
            ></el-input>
          </el-form-item>

          <div class="margin-left20">
            <el-button type="primary" @click="submitForm()">检 索</el-button>
            <el-button @click="resetForm()" class="resetbtn">重 置</el-button>
          </div>
        </el-form>
      </div>
      <!-- 内容 -->
      <div
        class="
          width100
          text-ellipsis
          backwhite
          pad-bot20
          margin-top15
          border-rd3
          alldigital
        "
        v-if="total != 0"
      >
        <div
          class="
            f14
            lineheight35
            pad-left20 pad-right20 pad-top20 pad-bot10
            bordert-tf
            dimencont
          "
          v-for="(item, index) in pages"
          :key="index"
        >
          <p class="f14 flex-betweennowrap cursorpointer dimensional">
            <span @click="toPatentdatails(index)"
              >{{ item.title }}({{ item.appNumber }})
              <span
                class="f12"
                :class="
                  item.dbName == '实用新型'
                    ? 'patensy'
                    : item.dbName == '外观专利'
                    ? 'patenwg'
                    : item.dbName == '发明专利'
                    ? 'patenzl'
                    : item.dbName == '发明授权'
                    ? 'patensq'
                    : ''
                "
                >{{ item.dbName }}</span
              ></span
            >
            <span
              class="cursorpointer attention"
              @click="addpatendfllow(index)"
            >
              加入关注
            </span>
          </p>
          <p
            class="width70 flex-betweennowrap pad-top10"
            @click="toPatentdatails(index)"
          >
            <span>公开(公告)号 : {{ item.pubNumber }}</span>
            <span>申请（专利权）人 : {{ item.patentee }}</span>
            <span> 发明（设计）人 : {{ item.inventroName }}</span>
          </p>
          <p class="width70 flex-betweennowrap">
            <span>国省代码 : {{ item.proCode }}</span>
            <span>申请日 : {{ item.appDate }} </span>
            <span>公开(公告)日 : {{ item.pubDate }}</span>
          </p>
          <p>分类号 : {{ item.ipc }}</p>
          <p>主分类号 : {{ item.mainIpc }}</p>
        </div>
        <!-- 分页 -->
        <div
          v-if="total != 0"
          class="
            flex-betweennowrap
            pad-top20 pad-bot20
            pagination
            pad-right10
            bordert-tf
          "
        >
          <span></span>
          <el-pagination
            :hide-on-single-page="true"
            @size-change="handleSizeChange"
            @current-change="currentchange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="per_page"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </div>
      </div>

      <div
        class="width100 margin-auto backgroudFFF margin-top15"
        v-if="total == 0"
      >
        <el-empty
          :image="require('@/assets/barsvg/zwsj@3x.png')"
          :image-size="200"
          description="抱歉，没有搜到您想要的内容"
          class="heightempty"
        >
          <p style="position: relative; bottom: 60px" class="f14">暂无数据</p>
        </el-empty>
      </div>
    </div>

    <el-dialog
      title=" "
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="20%"
      class="errorbox"
    >
      <p class="textalign-left">
        <span>提示</span>
      </p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { patentquerykey } from "@/api/patent/patent.api";
import callback from "@/components/callback.vue";
import { followpatentfllow } from "@/api/Center/Center.api";
import BUS from "@/BUS/BUS";
import switchcore from "@/components/switchcore.vue";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      searchcont: true,
      maincont: false,
      input2: "",
      ruleForm: {
        query_type: "", //查询方式
        title: "", //专利名称
        invetro: "", //发明人名称
        agency: "", //代理机构名称
        patentee: "", //权利人名称
        address: "", //权利人地址
        db: "", //专利类型
        ipc: "", //ipc分类号
        // abs: "",//摘要
        app_number: "", //申请号
        pub_number: "", //公开号
      },
      optiontype: [
        {
          name: "精确查询",
          id: "eq",
        },
        {
          name: "模糊查询",
          id: "like",
        },
      ],
      options: [
        {
          value: "FMZL",
          label: "发明专利",
        },
        {
          value: "WGZL",
          label: "外观专利",
        },
        {
          value: "SYXX",
          label: "实用新型",
        },
      ],
      thisNum: 1,
      pages: [],
      total: 0,
      per_page: 0,
      currentPage: 0,
      serchkey: true,
    };
  },
  components: {
    // Refresh,
    callback,
    switchcore,
  },
  methods: {
    changecont() {
      this.searchcont = false;
      this.maincont = true;
    },
    searchclick() {
      this.$loading.show(); // 显示loading
      patentquerykey({
        query_type: "like", //查询方式
        title: this.input2, //专利名称
        invetro: "", //发明人名称
        agency: "", //代理机构名称
        patentee: "", //权利人名称
        address: "", //权利人地址
        db: "", //专利类型
        ipc: "", //ipc分类号
        // abs: "",//摘要
        app_number: "", //申请号
        pub_number: "", //公开号
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          window.sessionStorage.setItem("titlep", this.input2);
          this.searchcont = false;
          this.maincont = true;
          this.ruleForm.title = this.input2;
          this.ruleForm.query_type = "like";
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.$message({
            showClose: true,
            message: "检索成功",
            type: "success",
          });
          if (
            this.pages == undefined ||
            this.pages == null ||
            this.pages == ""
          ) {
            this.total = 0;
          } else {
            this.pages.forEach((i) => {
              if (i.dbName == "SYXX") {
                i.dbName = "实用新型";
              }
              if (i.dbName == "FMZL") {
                i.dbName = "发明专利";
              }
              if (i.dbName == "WGZL") {
                i.dbName = "外观专利";
              }
              if (i.dbName == "FMSQ") {
                i.dbName = "发明授权";
              }
            });
          }
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      if (
        window.sessionStorage.getItem("query_typep") != null ||
        window.sessionStorage.getItem("titlep") != null ||
        window.sessionStorage.getItem("invetrop") != null ||
        window.sessionStorage.getItem("agencyp") != null ||
        window.sessionStorage.getItem("patenteep") != null ||
        window.sessionStorage.getItem("addressp") != null ||
        window.sessionStorage.getItem("dbp") != null ||
        window.sessionStorage.getItem("ipcp") != null ||
        window.sessionStorage.getItem("app_numberp") != null ||
        window.sessionStorage.getItem("pub_numberp") != null
      ) {
        this.searchcont = false;
        this.maincont = true;
        this.$loading.show(); // 显示loading
        patentquerykey({
          query_type: window.sessionStorage.getItem("query_typep"), //查询方式
          title: window.sessionStorage.getItem("titlep"), //专利名称
          invetro: window.sessionStorage.getItem("invetrop"), //发明人名称
          agency: window.sessionStorage.getItem("agencyp"), //代理机构名称
          patentee: window.sessionStorage.getItem("patenteep"), //权利人名称
          address: window.sessionStorage.getItem("addressp"), //权利人地址
          db: window.sessionStorage.getItem("dbp"), //专利类型
          ipc: window.sessionStorage.getItem("ipcp"), //ipc分类号
          // abs: "",//摘要
          app_number: window.sessionStorage.getItem("app_numberp"), //申请号
          pub_number: window.sessionStorage.getItem("pub_numberp"), //公开号
          page: this.thisNum,
          limit: 20,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$loading.hide(); // 隐藏loading
            this.pages = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
            if (
              this.pages == undefined ||
              this.pages == null ||
              this.pages == ""
            ) {
              this.total = 0;
            } else {
              this.pages.forEach((i) => {
                if (i.dbName == "SYXX") {
                  i.dbName = "实用新型";
                }
                if (i.dbName == "FMZL") {
                  i.dbName = "发明专利";
                }
                if (i.dbName == "WGZL") {
                  i.dbName = "外观专利";
                }
                if (i.dbName == "FMSQ") {
                  i.dbName = "发明授权";
                }
              });
            }
          } else {
            this.$loading.hide(); // 隐藏loading
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        this.total = 0;
        this.$loading.hide(); // 隐藏loading
      }
    },
    // 清空input
    resetForm() {
      this.ruleForm.query_type = "";
      this.ruleForm.title = "";
      this.ruleForm.invetro = "";
      this.ruleForm.agency = "";
      this.ruleForm.patentee = "";
      this.ruleForm.address = "";
      this.ruleForm.db = "";
      this.ruleForm.ipc = "";
      this.ruleForm.app_number = "";
      this.ruleForm.pub_number = "";
      this.pages = "";
      this.total = 0;
    },
    // 保存pantenid
    toPatentdatails(index) {
      window.sessionStorage.setItem("patentKey", this.pages[index].id);
      this.$router.push({ path: "/Data-Homepage/Patent-details" });
    },
    // 加入关注
    addpatendfllow(index) {
      followpatentfllow({ patent_id: this.pages[index].id }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "已加入",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 专利检索
    submitForm() {
      this.$loading.show(); // 显示loading
      window.sessionStorage.setItem("query_typep", this.ruleForm.query_type);
      window.sessionStorage.setItem("titlep", this.ruleForm.title);
      window.sessionStorage.setItem("invetrop", this.ruleForm.invetro);
      window.sessionStorage.setItem("agencyp", this.ruleForm.agency);
      window.sessionStorage.setItem("patenteep", this.ruleForm.patentee);
      window.sessionStorage.setItem("addressp", this.ruleForm.address);
      window.sessionStorage.setItem("dbp", this.ruleForm.db);
      window.sessionStorage.setItem("ipcp", this.ruleForm.ipc);
      window.sessionStorage.setItem("app_numberp", this.ruleForm.app_number);
      window.sessionStorage.setItem("pub_numberp", this.ruleForm.pub_number);
      patentquerykey({
        query_type: this.ruleForm.query_type, //查询方式
        title: this.ruleForm.title, //专利名称
        invetro: this.ruleForm.invetro, //发明人名称
        agency: this.ruleForm.agency, //代理机构名称
        patentee: this.ruleForm.patentee, //权利人名称
        address: this.ruleForm.address, //权利人地址
        db: this.ruleForm.db, //专利类型
        ipc: this.ruleForm.ipc, //ipc分类号
        // abs: "",//摘要
        app_number: this.ruleForm.app_number, //申请号
        pub_number: this.ruleForm.pub_number, //公开号
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.$message({
            showClose: true,
            message: "检索成功",
            type: "success",
          });
          if (
            this.pages == undefined ||
            this.pages == null ||
            this.pages == ""
          ) {
            this.total = 0;
          } else {
            this.pages.forEach((i) => {
              if (i.dbName == "SYXX") {
                i.dbName = "实用新型";
              }
              if (i.dbName == "FMZL") {
                i.dbName = "发明专利";
              }
              if (i.dbName == "WGZL") {
                i.dbName = "外观专利";
              }
              if (i.dbName == "FMSQ") {
                i.dbName = "发明授权";
              }
            });
          }
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 第一个分页
    currentchange(val) {
      this.$loading.show(); // 显示loading
      patentquerykey({
        query_type: window.sessionStorage.getItem("query_typep"), //查询方式
        title: window.sessionStorage.getItem("titlep"), //专利名称
        invetro: window.sessionStorage.getItem("invetrop"), //发明人名称
        agency: window.sessionStorage.getItem("agencyp"), //代理机构名称
        patentee: window.sessionStorage.getItem("patenteep"), //权利人名称
        address: window.sessionStorage.getItem("addressp"), //权利人地址
        db: window.sessionStorage.getItem("dbp"), //专利类型
        ipc: window.sessionStorage.getItem("ipcp"), //ipc分类号
        // abs: "",//摘要
        app_number: window.sessionStorage.getItem("app_numberp"), //申请号
        pub_number: window.sessionStorage.getItem("pub_numberp"), //公开号
        page: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          if (
            this.pages == undefined ||
            this.pages == null ||
            this.pages == ""
          ) {
            this.total = 0;
          } else {
            this.pages.forEach((i) => {
              if (i.dbName == "SYXX") {
                i.dbName = "实用新型";
              }
              if (i.dbName == "FMZL") {
                i.dbName = "发明专利";
              }
              if (i.dbName == "WGZL") {
                i.dbName = "外观专利";
              }
              if (i.dbName == "FMSQ") {
                i.dbName = "发明授权";
              }
            });
          }
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      this.$loading.show(); // 显示loading
      patentquerykey({
        query_type: window.sessionStorage.getItem("query_typep"), //查询方式
        title: window.sessionStorage.getItem("titlep"), //专利名称
        invetro: window.sessionStorage.getItem("invetrop"), //发明人名称
        agency: window.sessionStorage.getItem("agencyp"), //代理机构名称
        patentee: window.sessionStorage.getItem("patenteep"), //权利人名称
        address: window.sessionStorage.getItem("addressp"), //权利人地址
        db: window.sessionStorage.getItem("dbp"), //专利类型
        ipc: window.sessionStorage.getItem("ipcp"), //ipc分类号
        // abs: "",//摘要
        app_number: window.sessionStorage.getItem("app_numberp"), //申请号
        pub_number: window.sessionStorage.getItem("pub_numberp"), //公开号
        page: 1,
        limit: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          if (
            this.pages == undefined ||
            this.pages == null ||
            this.pages == ""
          ) {
            this.total = 0;
          } else {
            this.pages.forEach((i) => {
              if (i.dbName == "SYXX") {
                i.dbName = "实用新型";
              }
              if (i.dbName == "FMZL") {
                i.dbName = "发明专利";
              }
              if (i.dbName == "WGZL") {
                i.dbName = "外观专利";
              }
              if (i.dbName == "FMSQ") {
                i.dbName = "发明授权";
              }
            });
          }
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    window.sessionStorage.setItem("doctourlid", 0);
    window.sessionStorage.setItem("opendoctourlid", 0);

    if (window.sessionStorage.getItem("query_typep") != null) {
      this.ruleForm.query_type = window.sessionStorage.getItem("query_typep");
    }
    if (window.sessionStorage.getItem("titlep") != null) {
      this.ruleForm.title = window.sessionStorage.getItem("titlep");
    }
    if (window.sessionStorage.getItem("invetrop") != null) {
      this.ruleForm.invetro = window.sessionStorage.getItem("invetrop");
    }
    if (window.sessionStorage.getItem("agencyp") != null) {
      this.ruleForm.agency = window.sessionStorage.getItem("agencyp");
    }
    if (window.sessionStorage.getItem("patenteep") != null) {
      this.ruleForm.patentee = window.sessionStorage.getItem("patenteep");
    }
    if (window.sessionStorage.getItem("addressp") != null) {
      this.ruleForm.address = window.sessionStorage.getItem("addressp");
    }
    if (window.sessionStorage.getItem("dbp") != null) {
      this.ruleForm.db = window.sessionStorage.getItem("dbp");
    }
    if (window.sessionStorage.getItem("ipcp") != null) {
      this.ruleForm.ipc = window.sessionStorage.getItem("ipcp");
    }
    if (window.sessionStorage.getItem("app_numberp") != null) {
      this.ruleForm.app_number = window.sessionStorage.getItem("app_numberp");
    }
    if (window.sessionStorage.getItem("pub_numberp") != null) {
      this.ruleForm.pub_number = window.sessionStorage.getItem("pub_numberp");
    }
    this.$loading.show(); // 显示loading
    if (
      window.sessionStorage.getItem("query_typep") != null ||
      window.sessionStorage.getItem("titlep") != null ||
      window.sessionStorage.getItem("invetrop") != null ||
      window.sessionStorage.getItem("agencyp") != null ||
      window.sessionStorage.getItem("patenteep") != null ||
      window.sessionStorage.getItem("addressp") != null ||
      window.sessionStorage.getItem("dbp") != null ||
      window.sessionStorage.getItem("ipcp") != null ||
      window.sessionStorage.getItem("app_numberp") != null ||
      window.sessionStorage.getItem("pub_numberp") != null
    ) {
      this.searchcont = false;
      this.maincont = true;
      patentquerykey({
        query_type: window.sessionStorage.getItem("query_typep"), //查询方式
        title: window.sessionStorage.getItem("titlep"), //专利名称
        invetro: window.sessionStorage.getItem("invetrop"), //发明人名称
        agency: window.sessionStorage.getItem("agencyp"), //代理机构名称
        patentee: window.sessionStorage.getItem("patenteep"), //权利人名称
        address: window.sessionStorage.getItem("addressp"), //权利人地址
        db: window.sessionStorage.getItem("dbp"), //专利类型
        ipc: window.sessionStorage.getItem("ipcp"), //ipc分类号
        // abs: "",//摘要
        app_number: window.sessionStorage.getItem("app_numberp"), //申请号
        pub_number: window.sessionStorage.getItem("pub_numberp"), //公开号
        page: this.thisNum,
        limit: 20,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          if (
            this.pages == undefined ||
            this.pages == null ||
            this.pages == ""
          ) {
            this.total = 0;
          } else {
            this.pages.forEach((i) => {
              if (i.dbName == "SYXX") {
                i.dbName = "实用新型";
              }
              if (i.dbName == "FMZL") {
                i.dbName = "发明专利";
              }
              if (i.dbName == "WGZL") {
                i.dbName = "外观专利";
              }
              if (i.dbName == "FMSQ") {
                i.dbName = "发明授权";
              }
            });
          }
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    } else {
      this.total = 0;
      this.$loading.hide(); // 隐藏loading
    }
  },
  mounted() {},
};
</script>
<style scoped>
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin: 10px 20px 10px 0;
  width: 20%;
}
.patensy {
  color: #7b83ea;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #e8eaf9;
  border-radius: 11px;
}
.patenwg {
  color: #52c5cb;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #e4f1f5;
  border-radius: 11px;
}
.patenzl {
  color: #f96d68;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #f5e8eb;
  border-radius: 11px;
}
.patensq {
  color: #5599ff;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #e5ecfb;
  border-radius: 11px;
}
.dimencont:hover {
  background: #f9fcfc;
}
.addbut {
  color: #767676;
  margin: 5px 10px 0 0;
  padding: 3px;
  border: 1px solid #767676;
  border-radius: 3px;
  font-size: 12px;
}
.Keywordsinput >>> .el-input__inner {
  height: 50px;
  border: 1px solid rgba(82, 197, 203, 1);
  border-radius: 23px 0 0 23px;
  position: relative;
  left: 35%;
}
.Keywordsinput >>> .el-input-group__append,
.el-input-group__prepend {
  width: 60px;
  text-align: center;
  color: #fff;
  background: #52c5cb;
  border: 1px solid rgba(82, 197, 203, 1);
  border-radius: 0px 100px 100px 0px;
  position: relative;
  left: 25%;
  font-size: 16px;
}
.icon {
  font-size: 12px;
}
.el-input__inner {
  min-width: 180px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>